export default __webpack_public_path__ + "static/media/undraw_opinion_dxp8_1.6598a766.svg";